import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
/**
 * Transform mark from solid to transparent.
 */
export var FadeOut = function FadeOut(options) {
  return function (from, _, defaults) {
    var _from = _slicedToArray(from, 1),
      shape = _from[0];
    var _shape$style = shape.style,
      _shape$style$fillOpac = _shape$style.fillOpacity,
      fillOpacity = _shape$style$fillOpac === void 0 ? 1 : _shape$style$fillOpac,
      _shape$style$strokeOp = _shape$style.strokeOpacity,
      strokeOpacity = _shape$style$strokeOp === void 0 ? 1 : _shape$style$strokeOp,
      _shape$style$opacity = _shape$style.opacity,
      opacity = _shape$style$opacity === void 0 ? 1 : _shape$style$opacity;
    var keyframes = [{
      fillOpacity: fillOpacity,
      strokeOpacity: strokeOpacity,
      opacity: opacity
    }, {
      fillOpacity: 0,
      strokeOpacity: 0,
      opacity: 0
    }];
    return shape.animate(keyframes, Object.assign(Object.assign({}, defaults), options));
  };
};
FadeOut.props = {};